import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.35581 6.078C2.72529 6.23666 2.1744 6.62011 1.80665 7.1563C1.4389 7.69248 1.2796 8.34451 1.35868 8.98986C1.43777 9.63522 1.74979 10.2295 2.23612 10.661C2.72246 11.0925 3.34963 11.3316 3.99981 11.3333H4.66648M7.99981 14.6667V8.66667V14.6667ZM7.99981 14.6667L6.33314 13.3333L7.99981 14.6667ZM7.99981 14.6667L9.66648 13.3333L7.99981 14.6667Z",
			stroke: "white",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5532 4.75867C10.3253 3.85639 9.76288 3.0745 8.97991 2.57151C8.19694 2.06852 7.252 1.88207 6.33666 2.04994C5.42131 2.21782 4.60405 2.72746 4.05053 3.47556C3.49701 4.22367 3.24866 5.15425 3.35582 6.07867C3.35582 6.07867 3.45782 6.66667 3.66649 7.00001",
			stroke: "white",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3332 11.3333C11.8039 11.333 12.2692 11.233 12.6984 11.0399C13.1277 10.8468 13.5112 10.565 13.8237 10.213C14.1361 9.86099 14.3705 9.44681 14.5114 8.99769C14.6523 8.54858 14.6965 8.07472 14.641 7.6073C14.5856 7.13989 14.4318 6.68952 14.1897 6.28583C13.9476 5.88215 13.6228 5.5343 13.2367 5.26519C12.8505 4.99609 12.4117 4.81182 11.9492 4.72451C11.4866 4.63721 11.0109 4.64885 10.5532 4.75867L9.6665 5",
			stroke: "white",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDownloadIcon;
